import CalendarItemWithPerformanceCodeParticipation from './CalendarItemWithPerformanceCodeParticipation';

export default {
    ...CalendarItemWithPerformanceCodeParticipation,
    name: CalendarItemWithPerformanceCodeParticipation.name + '_resource',
};
